import React from 'react';

const AnimatedFadeIn = ({ children, delay = 0, direction = 'top' }) => {
  const animationClass =
    direction === 'top' ? 'fade-in-top' : 'fade-in-bottom';

  return (
    <div
      className={animationClass}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

export default AnimatedFadeIn;